import { Component, AfterViewInit, ElementRef, ViewChild, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import Map from 'ol/Map';
import View from 'ol/View';
import TileLayer from 'ol/layer/Tile';
import OSM from 'ol/source/OSM';
import { DxButtonModule, DxCheckBoxModule } from 'devextreme-angular';

@Component({
  selector: 'dk-open-layers-map',
  standalone: true,
  imports: [CommonModule,DxButtonModule,DxCheckBoxModule],
  templateUrl: './open-layers-map.component.html',
  styleUrls: ['./open-layers-map.component.scss'],
})
export class OpenLayersMapComponent {
    @ViewChild('mapEl', { static: true }) mapEl!: ElementRef<HTMLDivElement>;

  @Input() zoom = 10;
  @Input() center: [number, number] = [40.1135, 27.6426]; // enlem , boylam

  private map!: Map;

  layersPanelVisible:boolean = false;

  ngAfterViewInit(): void {
    this.map = new Map({
      target: this.mapEl.nativeElement,
      layers: [
        new TileLayer({
          source: new OSM()
        })
      ],
      view: new View({
        center: this.center,
        zoom: this.zoom,
        projection: 'EPSG:4326'
      })
    });
  }



  
}
